import { render, staticRenderFns } from "./SelectGender.vue?vue&type=template&id=f18803a0&"
import script from "./SelectGender.vue?vue&type=script&lang=js&"
export * from "./SelectGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports